import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';

import { TreeView } from 'devextreme-react/tree-view';

import { AppFooter } from '../..';
import { useNavigation } from '../../../contexts/navigation';
import { useUser } from '../../../contexts/user';
import { useScreenSize } from '../../../utils/media-query';

import './SideNavigationMenu.scss';

import * as events from 'devextreme/events';



export const SideNavigationMenu = (props) => {
  const { children, selectedItemChanged, openMenu, compactMode, onMenuReady } = props;

  const [items, setItems] = useState([]);
  const { navigation } = useUser();

  const { isLarge } = useScreenSize();

  useEffect(() => {
    if (navigation && navigation.length > 0) {
      var navMap = navigation.map((item) => ({ 
        ...item, 
        expanded: false, 
        path: item.path && !/^\//.test(item.path) ? `/${item.path}` : item.path 
      }));
      setItems(navMap);
    } else {
      setItems([]);
    }
  }, [navigation]);

  const {
    navigationData: { currentPath },
  } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, 'dxclick');
      }

      wrapperRef.current = element;
      events.on(element, 'dxclick', (e) => {
        openMenu(e);
      });
    },
    [openMenu]
  );

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance();
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div className='dx-swatch-additional side-navigation-menu' ref={getWrapperRef}>
      {children}
      <div className='menu-container theme-dependent'>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr='path'
          selectionMode='single'
          focusStateEnabled={false}
          expandEvent='click'
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width='100%'
        />
      </div>
      <AppFooter>
        Copyright © {new Date().getFullYear()} <br /> Computer Service Dresden GmbH
      </AppFooter>
    </div>
  );
};
